/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Detail_Group_EyebrowInputs */

const en_directory_taxonomy_detail_group_eyebrow = /** @type {(inputs: Directory_Taxonomy_Detail_Group_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category group`)
};

const zh_directory_taxonomy_detail_group_eyebrow = /** @type {(inputs: Directory_Taxonomy_Detail_Group_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类分组`)
};

/**
* | output |
* | --- |
* | "Category group" |
*
* @param {Directory_Taxonomy_Detail_Group_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_detail_group_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Detail_Group_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Detail_Group_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_detail_group_eyebrow(inputs)
	return zh_directory_taxonomy_detail_group_eyebrow(inputs)
});
export { directory_taxonomy_detail_group_eyebrow as "directory.taxonomy_detail.group.eyebrow" }